// extracted by mini-css-extract-plugin
export default {"primaryColor":"#404047","secondaryColor":"#f0f0f0","complementaryColor":"#369"};